import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class DeleteInventory extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Delete Store Inventory</h1>
				<p>This method deletes the specified inventory.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> DELETE </td>
							<td> {`/inventories/{inventory_id}`}</td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> inventory_id </td>
							<td> Integer </td>
							<td> </td>
							<td> The ID of the inventory to delete </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method.</p>
				<h4>Response</h4>
				<p>If successful, this method returns an empty "data".</p>
				<h4>Example</h4>
				<ul>
					<li>
						DELETE /inventories/1234
						<ul>
							<li>Deletes inventory #1234</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}